import { recipeService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    myRecipes: {},
    mySharedRecipes: {},
    recipeVariations: {},
    current: {},
    subrecipes: {},
    loading: false,
    update: '',
    clone: {}
  }
}

export const recipes = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllRecipes({ commit },params) {
      commit('getAllRecipesRequest');
      recipeService.getAll(params)
      .then(
          recipes => commit('getAllRecipesSuccess', recipes),
          error => commit('getAllRecipesFailure', error)
      );
    },
    getAllDeletedRecipes({ commit }) {
      commit('getAllRecipesRequest');
      recipeService.getAllDeleted()
      .then(
          recipes => commit('getAllRecipesSuccess', recipes),
          error => commit('getAllRecipesFailure', error)
      );
    },
    getMyRecipes({ commit }, params) {
      commit('getMyRecipesRequest');
      recipeService.getMyRecipes(params)
      .then(
          recipes => commit('getMyRecipesSuccess', recipes),
          error => commit('getMyRecipesFailure', error)
      );
    },
    getSubRecipes({ commit }, recipeId) {
      commit('getSubRecipesRequest');
      recipeService.getSubRecipes(recipeId)
      .then(
          recipes => commit('getSubRecipesSuccess', recipes),
          error => commit('getSubRecipesFailure', error)
      );
    },
    getMySharedRecipes({ commit }, payload) {
      commit('getMySharedRecipesRequest');
      recipeService.getMySharedRecipes(payload.userId)
      .then(
          recipes => commit('getMyRecipesSuccess', recipes),
          error => commit('getMyRecipesFailure', error)
      );
    },
    getRecipeVariations({ commit }, recipeId) {
      commit('getRecipeVariationsRequest');
      recipeService.getRecipeVariations(recipeId)
      .then(
          recipes => commit('getRecipeVariationsSuccess', recipes),
          error => commit('getRecipeVariationsFailure', error)
      );
    },
    getById({ commit }, params) {
      return recipeService.getById(params.recipeId, params.lang)
      .then(
          recipes => commit('getByIdSuccess', recipes),
          error => commit('getByIdFailure', error)
      );
    },
    async addRecipe({ commit }, payload){
      commit('addRecipeRequest');
      await recipeService.addRecipe(payload)
      .then(
        recipe => commit('addRecipeSuccess', recipe),
        error => commit('addRecipeFailure', error)
      )
    },
    async updateRecipe({ commit }, payload){
      commit('updateRecipeRequest');
      await recipeService.updateRecipe(payload)
      .then(
        recipe => commit('updateRecipeSuccess', recipe),
        error => commit('updateRecipeFailure', error)
      )
    },
    removeRecipe({ commit }, payload) {
      commit('removeRecipeRequest');
      recipeService.removeRecipe(payload)
      .then(
        response => commit('removeRecipeSuccess', response),
        error => commit('removeRecipeFailure', error)
      )
    },
    cloneRecipe({ commit }, payload) {
      commit('cloneRecipeRequest');
      recipeService.cloneRecipe(payload)
      .then(
        response => commit('cloneRecipeSuccess', response),
        error => commit('cloneRecipeFailure', error)
      )
    },
    searchRecipes({ commit }, params) {
      commit('getAllRecipesRequest');
      recipeService.searchRecipes(params)
      .then(
          recipes => commit('getSearchRecipesSuccess', recipes),
          error => commit('getSearchRecipesFailure', error)
      );
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllRecipesRequest(state) {
        state.loading = 'Loading'
    },
    getAllRecipesSuccess(state, recipes) {
        state.all = Object.values(recipes)
        state.loading = false
    },
    getAllRecipesFailure(state, error) {
        state.all = { error }
        state.loading = 'failed'
    },
    getSearchRecipesSuccess(state, recipes) {
        state.all = Object.values(recipes)
        state.loading = false
    },
    getSearchRecipesFailure(state, error) {
        state.all = { error };
        state.loading = 'failed'
    },
    getMyRecipesRequest(state) {
        state.loading = 'Loading'
    },
    getMyRecipesSuccess(state, recipes) {
      state.myRecipes = Object.values(recipes)
      state.loading = false
    },
    getMyRecipesFailure(state, error) {
      state.myRecipes = { error };
      state.loading = 'failed'
    },
    getSubRecipesRequest(state) {
        state.loading = 'Loading'
    },
    getSubRecipesSuccess(state, recipes) {
      state.subrecipes = Object.values(recipes)
      state.loading = false
    },
    getSubRecipesFailure(state, error) {
      state.subrecipes = { error };
      state.loading = 'failed'
    },
    getMySharedRecipesRequest(state) {
        state.loading = 'Loading'
    },
    getMySharedRecipesSuccess(state, recipes) {
      state.mySharedRecipes = Object.values(recipes)
      state.loading = false
    },
    getMySharedRecipesFailure(state, error) {
      state.mySharedRecipes = { error };
      state.loading = false
    },
    getRecipeVariationsRequest(state) {
        state.loading = 'Loading'
    },
    getRecipeVariationsSuccess(state, recipes) {
      state.recipeVariations = Object.values(recipes)
      state.loading = false
    },
    getRecipeVariationsFailure(state, error) {
      state.recipeVariations = { error };
      state.loading = false
    },
    getByIdRequest(state) {
      state.current = { loading: true };
      state.loading = 'Loading'
    },
    getByIdSuccess(state, recipe) {
      state.current = recipe
      state.loading = false
    },
    getByIdFailure(state, error) {
        state.current = { error };
        state.loading = 'failed'
    },
    addRecipeRequest(state, recipe){
      state.update = '';
      state.loading = 'Loading'
    },
    addRecipeSuccess(state, recipe) {
      state.current = recipe;
      state.loading = 'Saved'
    },
    addRecipeFailure(state, error) {
      state.update = { error };
      state.loading = false;
    },
    updateRecipeRequest(state, recipe){
      state.update = '';
      state.loading = 'Loading'
    },
    updateRecipeSuccess(state, recipe) {
      //state.current = recipe;
      state.loading = 'Saved'
    },
    updateRecipeFailure(state, error) {
      state.update = { error };
      state.loading = false;
    },
    removeRecipeRequest(state, recipe){
      state.loading = 'Loading'
    },
    removeRecipeSuccess(state, recipe) {
      state.loading = false
    },
    removeRecipeFailure(state, error) {
      state.loading = false
    },
    cloneRecipeRequest(state, recipe){
      state.loading = 'Loading'
    },
    cloneRecipeSuccess(state, recipe) {
      state.loading = false;
      state.clone = recipe;
    },
    cloneRecipeFailure(state, error) {
      state.loading = false
    }
  }
}